import React, {useState, useEffect} from 'react';
import { TopBar } from "../../shared/topBar/TopBar";
import { UrlPath } from "../../../config/routeConfig";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { toast, ToastContainer } from "react-toastify";
import { sbaAxios } from "../../utils/sbaAxios";
import burgermenu from "../../asset/returnsandstatistics/images/burger-menu.svg";
import linechartup from "../../asset/returnsandstatistics/images/line-chart-up-01.svg";
import {
  SBAComboBox,
} from "../../UiComponents/SBADropDown";

import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import { AgGridReact } from "ag-grid-react";
import moment from 'moment';
import { getClientStatementAPI, getMarketDataIndices, getPortfolioPerfAndStats } from '../../../config/apiConfig';
import PerfAndStatsGrid from './PerfAndStatsGrid';
import PortfolioChart from './PortfolioChart';
const PerfAndStats = () => {

    const Level = [{ BreadCrumb: "Portfolio >", Routes: `${UrlPath.PortfolioList}` }, {BreadCrumb:"Performance & Statistics", Routes:`${UrlPath.PortfolioPerfAndStats}`}];
    const now = new Date();
    const LastMonthEndDate = new Date(now.getFullYear(), now.getMonth(), 0);
    const [clientStatementList, setClientStatementList] = useState([]);
    const [selectedClientStatement, setSelectedClientStatement] = useState(null);
    const [reportDate, setReportDate] = useState(LastMonthEndDate);
    const [bm1list, setbm1list] = useState([]);
    const [selectedBM1, setSelectedBM1] = useState(null);
    const [bm2list, setbm2list] = useState([]);
    const [selectedBM2, setSelectedBM2] = useState(null);
    const [useWeightedIndex, setUseWeightedIndex] = useState(false);
    const [rowData, setRowData] = useState(null);

    const [gridbuttonActive, setGridbuttonActive] = useState(true);
    const [chartbuttonActive, setChartbuttonActive] = useState(false);
    
    const [chartData,setChartData]=useState(null);

    const getClientStatementData = async() => {
        await sbaAxios({ url: getClientStatementAPI }).then(res => {
            setClientStatementList(res);
    
        }).catch(e => {
          console.log(e, 'Error Loading the Client Statement Data');
          setClientStatementList([]);
        })
    };
    const getmarketdata = async () => {
        try {
            const response = await sbaAxios({
                url: `${getMarketDataIndices}`,
                method: 'get',
            });

            setbm1list(response); 
            setbm2list(response);
        } catch (error) {
            console.error('Error fetching market data:', error);   
        }
    };

    const fetchPortfolioPerfAndStats = async() => {
      const bm = [
        selectedBM1?.MarketIndexId,
        selectedBM2?.MarketIndexId
      ];
        const selectedbmIds = bm.filter(Boolean).join('~');
        if(selectedClientStatement === null){
            toast.error('Please Select a Client Statement');
            return;
        }
        if(selectedBM1 === null){
            toast.error('Please Select BM1');
            return;
        }
        if(selectedBM2 === null){
            toast.error('Please Select BM2');
            return;
        }
        const reportDateString = reportDate.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
          }).replace(/\//g, '-');
        try{
  
            const response = await sbaAxios({
                url:`${getPortfolioPerfAndStats}/${selectedClientStatement.ClientStatementId},${reportDateString},${selectedbmIds},${selectedbmIds}`
            });
            setRowData(response);
            setChartData({...response,ClientStatementName:selectedClientStatement.ClientStatementName});
        }
        catch(e){
            setRowData(null);
        }
        
    }
  

    useEffect(()=>{
        getClientStatementData();
        getmarketdata();
        document.title="Perfromance and Statistics"
    },[]);
    const portfolios=[
        {value:1,text:"Advised Performing"},
        {value:2,text:"Total Performing"},
        {value:3,text:"Both"},
  ];
    const periods = [{ value: 3, text: "3 Years" },
    { value: 5, text: "5 Years" },
    { value: 0, text: "Inception" },];
 

  const [selectedPortfolio,setSelectedPortfolio]=useState(portfolios[0]);
  const [selectedPeriods,setSelectedPeriods]=useState(periods[0]);
    return (
      <>
        <TopBar label={"Performance & Statistics"} />
        <div className="mainContentData">
          <BreadCrumbs Levels={Level} />
          <div className="container-fluid p-4">
            <div className="row">
              <div className="col-md-3">
                <label className="label">Client Statements</label>
                <div>
                  <SBAComboBox
                    className="w-100"
                    data={clientStatementList}
                    textField={"ClientStatementName"}
                    valueField={"ClientStatementId"}
                    value={selectedClientStatement}
                    onChange={(e) => setSelectedClientStatement(e.value)}
                    popupSettings={{ className: "modalDD" }}
                  ></SBAComboBox>
                </div>
              </div>
              <div className="col-md-3">
                <label className="label">Report Date</label>
                <div>
                  <SBDatePicker
                    className="form-control"
                    value={moment(reportDate)}
                    onChange={(e) => {
                      setReportDate(new Date(e));
                    }}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <label className="label">BM 1</label>
                <div>
                  <SBAComboBox
                    className="w-100"
                    data={bm1list}
                    textField={"MarketIndexName"}
                    valueField={"MarketIndexId"}
                    value={selectedBM1}
                    onChange={(e) => setSelectedBM1(e.value)}
                    popupSettings={{ className: "modalDD" }}
                  ></SBAComboBox>
                </div>
              </div>
              <div className="col-md-3">
                <label className="label">BM 2</label>
                <div>
                  <SBAComboBox
                    className="w-100"
                    data={bm2list}
                    textField={"MarketIndexName"}
                    valueField={"MarketIndexId"}
                    value={selectedBM2}
                    onChange={(e) => setSelectedBM2(e.value)}
                    popupSettings={{ className: "modalDD" }}
                  ></SBAComboBox>
                </div>
              </div>
            </div>
            <div className="row mt-4 align-items-center">
              <div className="col-md-6">
                <div className="d-flex align-items-center gap-2">
                  <CheckContainer
                    label={"Use Weighted Index"}
                    value={useWeightedIndex}
                    onChange={setUseWeightedIndex}
                    nowrap={true}
                  />
                   <div className="col-md-3">
                <label className="label">Portfolio</label>
                  <SBAComboBox
                    className="w-100"
                    data={portfolios}
                    textField={"text"}
                    valueField={"value"}
                    value={selectedPortfolio}
                    onChange={(e) => {if(e.value)setSelectedPortfolio(e.value)}}
                  ></SBAComboBox>
                  </div>

                   {/* <div className="col-md-3">
                <label className="label">Periods</label>
                    <SBAComboBox
                    className="w-100"
                    data={periods}
                    textField={"text"}
                    valueField={"value"}
                    value={selectedPeriods}
                    onChange={(e) =>{if(e.value) setSelectedPeriods(e.value)}}
                  ></SBAComboBox>
                  </div> */}
                  <button
                    className="p-sm-btn  mt-auto"
                    onClick={() => {
                      fetchPortfolioPerfAndStats();
                    }}
                    disabled={!(selectedClientStatement?.ClientStatementId && selectedBM1?.MarketIndexId && selectedBM2?.MarketIndexId)}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    // title="Click to remove the cached excel file from GenAI model"
                  >
                    Go
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row p-3 m-0 mt-2 justify-content-between align-items-start">
  {/* Left Side - Grid & Chart Toggle */}
  <div className="col-md-6 d-flex align-items-center">
    <div className="d-inline-flex">
      <button
        className={`toggle-btn rounded-start ${gridbuttonActive ? "active" : ""}`}
        onClick={() => {
          setGridbuttonActive(true);
          setChartbuttonActive(false);
        }}
      >
        <span>
          <img
            src={burgermenu}
            alt=""
            style={{
              filter: gridbuttonActive ? "brightness(100%)" : "brightness(50%)",
            }}
          />
        </span>{" "}
        Grid View
      </button>
      <button
        className={`toggle-btn rounded-end ${chartbuttonActive ? "active" : ""}`}
        onClick={() => {
          setGridbuttonActive(false);
          setChartbuttonActive(true);
        }}
      >
        <span>
          <img
            src={linechartup}
            alt=""
            style={{
              filter: chartbuttonActive ? "brightness(100%)" : "brightness(50%)",
            }}
          />
        </span>{" "}
        Chart View
      </button> 

    </div>
  </div>

  {/* Right Side - Chart Buttons */}
  

            <div >
            {gridbuttonActive ? 
            <PerfAndStatsGrid
                  gridData={rowData}
                  weightedIndex={useWeightedIndex}
                  portfolio={selectedPortfolio}
                  index={{selectedBM1,selectedBM2}}
                /> :
                <div className='p-3'><PortfolioChart data={chartData} period={selectedPeriods} portfolio={selectedPortfolio}  weightedIndex={useWeightedIndex} csName={selectedClientStatement?.ClientStatementName}></PortfolioChart></div>}
            </div>
          </div>

        </div>
        <ToastContainer />
      </>
    );
};

const CheckContainer = ({ label, value, onChange, nowrap, ...props }) => {
    return (
        <div className="mt-auto p-2">
            <span className="mx-2 d-flex">
                <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => { onChange(!value) }}
                    {...props}
                />
                {/* <label className="ms-2 wrap-label">{label}</label> */}
                <label className={`ms-2 ${nowrap ? 'nowrap-label' : 'wrap-label'}`}>{label}</label>
            </span>
        </div>
    );
};

export default PerfAndStats;